import { Topbar } from '@shared/ui/topbar';
import { Loading } from '@shared/ui/loading';

import styles from './collection.module.css';

/**
 * `collections/$id`'s own `pendingComponent` (`templates/morningstar/
 * app.router.tsx`), same reasoning as `pages/preview/ui/route-loading.tsx`
 * (improvements/07.1-per-template-issue-reader-widgets.md): this route is a
 * plain `React.lazy()`-wrapped `component`, not TanStack's own `.lazy()`
 * route-splitting, but `pendingComponent` still catches it -- the router
 * implements it as a real Suspense boundary around the route's rendered
 * subtree, and Suspense doesn't distinguish *why* a child suspended.
 * Without this, the window while `Collection`'s chunk loads fell back to
 * `createTenantApp`'s generic `RoutePending` (no real navbar).
 */
export function CollectionRouteLoading() {
	return (
		<div className={styles['container']}>
			<div className={styles['view']}>
				<Topbar />
				<div className={styles['loading']}>
					<Loading />
				</div>
			</div>
		</div>
	);
}
